/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import {
  coreServicesBenefitsUrl,
  enhancedPersonalServicesBenefitsUrl,
  personalServicesBenefitsUrl,
  wallStreetJournalAuthTokenUrls
} from 'services/Externals';
import {
  SERVICE_TYPE_CORE,
  SERVICE_TYPE_PFD,
  SERVICE_TYPE_HNW,
  SERVICE_TYPE_MIL
} from 'services/ServiceBenefits';

const turboTaxBenefitUrl = (type = SERVICE_TYPE_CORE) => {
  if (type === SERVICE_TYPE_PFD || type === SERVICE_TYPE_HNW) {
    return window.getTTOUrl
      ? window.getTTOUrl('https://turbotax.intuit.com/affiliate/g5fyo7u3')
      : '/#';
  } else if (type === SERVICE_TYPE_MIL) {
    return window.getTTOUrl
      ? window.getTTOUrl('https://turbotax.intuit.com/affiliate/6jqpfte5')
      : '/#';
  }
  return null;
};

const morningStarBenefitUrl = (type = SERVICE_TYPE_CORE) => {
  if (type === SERVICE_TYPE_PFD) {
    return 'https://www3.troweprice.com/retailtools/mstar/pages/mfi/selectclient/psMStarBegin.jsp?scn=Client_Benefits';
  } else if (type === SERVICE_TYPE_HNW) {
    return 'https://www3.troweprice.com/retailtools/mstar/pages/mfi/selectclient/psMStarBegin.jsp?scn=Personal_Services_Benefits';
  } else if (type === SERVICE_TYPE_MIL) {
    return 'https://www3.troweprice.com/retailtools/mstar/pages/mfi/selectclient/psMStarBegin.jsp?scn=Enhanced_Personal_Services_Benefits';
  }
  return null;
};

const turboTaxConfig = (type = SERVICE_TYPE_CORE) => {
  return {
    benefitType: 'turbotax',
    benefitContent:
      'Simplify your taxes with a selection of free TurboTax products.',
    benefitUrl: turboTaxBenefitUrl(type),
    newTab: true,
    className: 'turbotax-view-link-button'
  };
};

const morningStarConfig = (type = SERVICE_TYPE_CORE) => {
  return {
    benefitType: 'morningstar',
    benefitContent:
      'This complimentary membership entitles you to full Premium privileges on Morningstar.com.',
    benefitUrl: morningStarBenefitUrl(type),
    newTab: true
  };
};

const wallStreetJournalConfig = () => {
  return {
    benefitType: 'wallstreetjournal',
    benefitContent:
      'Gain full access to the Online Journal, exclusive to Enhanced Personal Services clients.',
    benefitUrl: wallStreetJournalAuthTokenUrls.authUrl,
    newTab: true
  };
};

export const allBenefitsUrl = (type = SERVICE_TYPE_CORE) => {
  if (type === SERVICE_TYPE_HNW) {
    return personalServicesBenefitsUrl();
  } else if (type === SERVICE_TYPE_MIL) {
    return enhancedPersonalServicesBenefitsUrl();
  } else if (type === SERVICE_TYPE_CORE) {
    return coreServicesBenefitsUrl();
  }
  return null;
};

export const serviceBenefitsConfig = (type = SERVICE_TYPE_CORE) => {
  if (type === SERVICE_TYPE_PFD || type === SERVICE_TYPE_HNW) {
    return [morningStarConfig(type), turboTaxConfig(type)];
  } else if (type === SERVICE_TYPE_MIL) {
    return [
      wallStreetJournalConfig(),
      morningStarConfig(type),
      turboTaxConfig(type)
    ];
  }
  return [];
};
